/**
 * CrossBranchMixin - Utility mixin for cross-branch data visualization
 *
 * Provides methods to identify and style items from other branches
 */
export default {
  computed: {
    /**
     * Get current user's branch ID from Vuex store
     */
    currentBranchId() {
      return this.$store.getters['moduleUser/getBranchInfo']?.id;
    }
  },
  methods: {
    /**
     * Check if item is from a different branch
     * @param {number} itemBranchId - Branch ID of the item
     * @returns {boolean} True if item is from another branch
     */
    isOtherBranch(itemBranchId) {
      // branchId === 0 means template (not branch-specific)
      if (!itemBranchId || itemBranchId === 0) return false;
      return itemBranchId !== this.currentBranchId;
    },

    /**
     * Get CSS class for cross-branch styling
     * @param {number} itemBranchId - Branch ID of the item
     * @returns {string} CSS class name
     */
    getCrossBranchClass(itemBranchId) {
      return this.isOtherBranch(itemBranchId) ? 'other-branch-item' : '';
    },

    /**
     * Get branch name by ID from store
     * @param {number} branchId - Branch ID
     * @returns {string} Branch name or empty string
     */
    getBranchName(branchId) {
      // Try to get from current branch info first
      const currentBranch = this.$store.getters['moduleUser/getBranchInfo'];
      if (currentBranch?.id === branchId) {
        return currentBranch.name || '';
      }
      // For other branches, return the branchId as fallback
      // (actual branch name would need to be in the API response)
      return '';
    }
  }
};
